import React from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import TextButton from 'components/TextButton';
import icon from 'resources/icon-close-gray.svg';
import './ADialog.css';

//  ----------------------------------------------------------------------------------------------//

class ADialog extends React.Component {
  render() {
    const {
      className,
      show,
      onClose,
      title,
      message,
      closeIcon,
      closeBtnVariant,
      closeBtnClassName,
      closeBtnCaption,
      buttons,
      children,
      hideHeader,
      hideFooter,
      backdrop,
      ...otherProps
    } = this.props;

    return (
      <Modal
        className={'a-dialog ' + className}
        show={show}
        onHide={onClose}
        animation={false}
        {...otherProps}
        backdrop={backdrop}
      >
        {title !== false && hideHeader !== true ? (
          <Modal.Header>
            <Modal.Title>{title}</Modal.Title>
          </Modal.Header>
        ) : null}

        <Modal.Body>
          {children ? children : <span className="message">{message}</span>}
        </Modal.Body>

        {hideFooter !== true ? (
          <Modal.Footer>
            {buttons && buttons.length
              ? buttons.map((btn, idx) => (
                  <Button
                    key={idx}
                    variant={(!btn.disabled && btn.variant) || null}
                    className={`${btn.className || ''} ${
                      btn.disabled ? 'btn-disabled' : ''
                    }`}
                    onClick={btn.onClick || this.props.onClose}
                    disabled={btn.disabled}
                  >
                    {btn.caption}
                  </Button>
                ))
              : null}

            <Button
              className={closeBtnClassName || ''}
              variant={closeBtnVariant || null}
              onClick={onClose}
            >
              {closeBtnCaption}
            </Button>
          </Modal.Footer>
        ) : null}

        {closeIcon ? (
          <div className="dialog-close-button">
            <TextButton onClick={onClose}>
              <img src={icon} alt="Close Dialog" />
            </TextButton>
          </div>
        ) : null}
      </Modal>
    );
  }
}
// || 'default'
ADialog.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  className: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  closeIcon: PropTypes.bool,
  closeBtnCaption: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  closeBtnVariant: PropTypes.string,
  hideHeader: PropTypes.bool,
  hideFooter: PropTypes.bool,
  backdrop: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),

  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      onClick: PropTypes.func,
      variant: PropTypes.string,
      caption: PropTypes.string
    })
  )
};

ADialog.defaultProps = {
  show: false,
  title: 'Confirm',
  closeBtnCaption: 'Close',
  closeBtnVariant: '',
  buttons: [],
  className: '',
  hideHeader: false,
  hideFooter: false,
  backdrop: 'static'
};

export default ADialog;
